import './App.css';
import AppCompoentRoot from './components/appcompoentroot/appCompoentRoot';
function App() {
	return (
		<div className='App'>
			<AppCompoentRoot />
		</div>
	);
}

export default App;
